// @flow
export const getProfile = store => store.profile;
